import { StyleSheet } from 'react-native'

const useStyles = (theme) => StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  stopsNumber: {
    width: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 2,
    borderWidth: 1,
    borderColor: theme.GAYSER
  },
  iconContainer: {
    marginRight: 15
  },
  locationContainer: {
    flex: 3
  },
  timeContainer: {
    flex: 2
  },
  infoContainerRow: {
    flexDirection: 'row',
    flex: 1
  },
  divider: {
    marginVertical: 10
  }
})

export default useStyles
